import { render, staticRenderFns } from "./UserStripe.vue?vue&type=template&id=b8a9318a&"
import script from "./UserStripe.vue?vue&type=script&lang=js&"
export * from "./UserStripe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports